const ALLOWED_MIME_TYPES = new Set(['image/png', 'image/jpeg']);
const MAX_FILE_SIZE_BYTES = 15 * 1024 * 1024;
const MAX_PIXELS = 50_000_000;

export async function validateImageFile(
  file: File,
): Promise<{ ok: true } | { ok: false; reason: string }> {
  if (!ALLOWED_MIME_TYPES.has(file.type)) {
    return { ok: false, reason: 'unsupported type' };
  }

  if (file.size > MAX_FILE_SIZE_BYTES) {
    return { ok: false, reason: 'too large' };
  }

  let bmp: ImageBitmap | null = null;
  try {
    bmp = await createImageBitmap(file);
    if (bmp.width * bmp.height > MAX_PIXELS) {
      return { ok: false, reason: 'too many pixels' };
    }
  } catch {
    return { ok: false, reason: 'not a valid image' };
  } finally {
    bmp?.close();
  }

  return { ok: true };
}
